import styled from "@emotion/styled";
import { useNewsByIsin } from "@rentablo/api/apiv1";
import {
  NoNewsText,
  NewsItemSkeleton,
} from "@features/investments/components/NewsList";
import { NewsList } from "@features/investments/components/NewsList";

interface Props {
  isin: string;
}

const NewsItemSkeletonContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing(6)};
`;

export const InvestmentNewsFeedList = ({ isin }: Props) => {
  const { data: newsData, isFetching: isNewsLoading } = useNewsByIsin({
    isin,
  });

  if (isNewsLoading)
    return (
      <NewsItemSkeletonContainer>
        <NewsItemSkeleton />
        <NewsItemSkeleton />
        <NewsItemSkeleton />
      </NewsItemSkeletonContainer>
    );

  if (!newsData?.feedItems) return <NoNewsText />;

  return <NewsList items={newsData?.feedItems} />;
};
